import type { ReactNode } from "react";
import { Modal } from "./Modal";
import { Alert, Button } from "./ui";

/**
 * The last check before an operation changes somebody else's account or
 * workload. It names the target and effect instead of asking for a generic
 * confirmation, which is useful when several tenant tabs are open at once.
 */
export function ConfirmActionModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  consequence,
  confirmLabel,
  danger = false,
  loading = false,
  error,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  consequence: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  loading?: boolean;
  error?: Error | null;
}) {
  return (
    <Modal open={open} onClose={onClose} title={title} description={description} dismissable={!loading}>
      <div className="space-y-5">
        {error && <Alert>{error.message}</Alert>}
        <p className="text-sm leading-6 text-fg-muted">{consequence}</p>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button
            type="button"
            variant="secondary"
            disabled={loading}
            onClick={onClose}
            className="w-full sm:w-auto"
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant={danger ? "danger" : "primary"}
            loading={loading}
            onClick={onConfirm}
            className="w-full sm:w-auto"
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
